"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
var lib_1 = require("@syl-editor/lib");
var link_1 = require("../reacts/link");
exports.LinkPlugin = link_1.LinkPlugin;
var image_1 = require("../reacts/image");
exports.ImagePlugin = image_1.ImagePlugin;
exports.InlineImagePlugin = image_1.InlineImagePlugin;
var video_1 = require("../reacts/video");
exports.VideoPlugin = video_1.VideoPlugin;
var audio_1 = require("../reacts/audio");
var color_1 = require("../reacts/color");
exports.ColorPlugin = color_1.ColorPlugin;
var background_1 = require("../reacts/background");
exports.BackgroundPlugin = background_1.BackgroundPlugin;
var emoji_util_1 = require("../modules/toolbar/toolbar-utils/emoji-util");
exports.EmojiUtil = emoji_util_1.EmojiUtil;
var anchor_util_1 = require("../modules/toolbar/toolbar-utils/anchor-util");
exports.AnchorUtil = anchor_util_1.AnchorUtil;
var Editor_1 = require("../Editor");
exports.SylEditor = Editor_1.SylEditor;
var card_1 = require("../card");
exports.Card = card_1.Card;
exports.InlineCard = card_1.InlineCard;
var toolbar_1 = require("../modules/toolbar");
exports.Toolbar = toolbar_1.Toolbar;
var render_bridge_1 = require("../render-bridge");
exports.ReactRenderer = render_bridge_1.ReactRenderer;
var link_2 = require("../reacts/link/link");
exports.setLinkConfiguration = link_2.setLinkConfiguration;
exports.utils = {
    emoji: emoji_util_1.EmojiUtil,
    anchor: anchor_util_1.AnchorUtil,
    align_left: lib_1.AlignLeftUtil,
    align_center: lib_1.AlignCenterUtil,
    align_right: lib_1.AlignRightUtil,
    align_justify: lib_1.AlignJustifyUtil,
    space_after: lib_1.SpaceAfterUtil,
    space_before: lib_1.SpaceBeforeUtil,
    space_both: lib_1.SpaceBothUtil,
    line_height: lib_1.LineHeightUtil,
    line_indent: lib_1.LineIndentUtil,
    format_painter: lib_1.FormatPainterUtil
};
exports.plugins = {
    background: background_1.BackgroundPlugin,
    block_quote: lib_1.BlockQuotePlugin,
    bold: lib_1.BoldPlugin,
    bullet_list: lib_1.BulletListPlugin,
    code_block: lib_1.CodeBlockPlugin,
    color: color_1.ColorPlugin,
    letter_space: lib_1.LetterSpacePlugin,
    fontfamily: lib_1.FontFamilyPlugin,
    font_size: lib_1.FontSizePlugin,
    format_clear: lib_1.FormatClearPlugin,
    header: lib_1.HeaderPlugin,
    header1: lib_1.Header1Plugin,
    header2: lib_1.Header2Plugin,
    header3: lib_1.Header3Plugin,
    hr: lib_1.HrPlugin,
    image: image_1.ImagePlugin,
    italic: lib_1.ItalicPlugin,
    link: link_1.LinkPlugin,
    list_item: lib_1.ListItemPlugin,
    mark: lib_1.MarkPlugin,
    ordered_list: lib_1.OrderedListPlugin,
    strike: lib_1.StrikePlugin,
    sub: lib_1.SubPlugin,
    sup: lib_1.SupPlugin,
    paragraph: lib_1.ParagraphPlugin,
    underline: lib_1.UnderlinePlugin,
    video: video_1.VideoPlugin,
    audio: audio_1.AudioPlugin
};
//# sourceMappingURL=main.js.map